import { render, staticRenderFns } from "./InviteClient.vue?vue&type=template&id=2147a3f4"
import script from "./InviteClient.vue?vue&type=script&lang=js"
export * from "./InviteClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports